import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardFooter,
  CardBlock,
  FormText,
  InputGroup,
  Input,
  InputGroupAddon
} from "reactstrap";

import * as Constant from '../../../constants/AppConstants';
import axios from 'axios';

import { loadProgressBar } from 'axios-progress-bar';
 loadProgressBar()

class Comments extends Component {
  constructor(props){
    super(props)
    // console.log("Comments lead_id" + this.props.id);
    this.getComments = this.props.getComments;
    this.state = {
      lead_id: this.props.id,
      comments: this.props.comments,
      chunkSize: 3,
    }
  }

  componentDidMount(){
    // console.log("componentDidMount");
    this.getComments();
  }

  render(){
    return (
      <div style ={{height: '500px', overflow:'scroll'}}>
        { this.props.comment===[] ? <div></div> :
        this.props.comments.map((data,key)=>{
        return (
          <Card style={{margin: 0 + 'em'}} key={key}>
            <CardBlock className='card-body' style={{padding: 0.25 + 'em'}}>
              <Row>
                <Col xs="12" sm="12" md="12" style={{textAlign:'left'}}>
                  {data.comment}
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="12" md="12" style={{textAlign:'right'}}>
                  <FormText color="muted"><strong>{(data.create_date).substr(0,20)}</strong>&nbsp;</FormText>
                {data.organization_id == null ? <img src={'img/avatars/logo.png'} className="comment-avatar"/>:<span></span>}
                </Col>
              </Row>
            </CardBlock>
          </Card>
        )
      })
      }
      </div>
    )
  }
}

export default Comments;



// WEBPACK FOOTER //
// ./src/views/Pages/LoanApplicationDetails/Comments.js